// extracted by mini-css-extract-plugin
export const newsletter = "newsletter-signup-module--newsletter--JrI_R";
export const newsletterDescription = "newsletter-signup-module--newsletterDescription--2UcNs";
export const newsletterLink = "newsletter-signup-module--newsletterLink--2Mubg";